import { css } from '@Root/lib/lit-3form-block';

export const styles = [
  css`
    .steve-layout {
      grid-template-rows:
        var(--block-top-padding)
        minmax(0, auto)
        minmax(0, auto)
        var(--block-bottom-padding)
        [last-line];
      max-width: 100%;
      width: 100%;
    }

    .steve-header {
      grid-column: 2 / 8;
      grid-row: 2;
      /* An h2 element rendered at H3 size per design. */
      font-size: var(--fs-title);
      line-height: var(--lh-title);
      letter-spacing: var(--ls-title);
      /* Design wants 30px to the cards; the grid row gap already gives 15. */
      padding-bottom: calc(15rem / var(--default-rem-px-count));
    }

    .steve-cards {
      grid-column: 2 / 8;
      grid-row: 3;
      display: grid;
      grid-template-columns: 1fr;
      gap: calc(40rem / var(--default-rem-px-count));
    }

    .steve-card {
      display: flex;
      flex-direction: column;
    }

    .steve-card img {
      display: block;
      width: 100%;
      height: auto;
    }

    .steve-card-description {
      margin-top: calc(20rem / var(--default-rem-px-count));
    }

    @media (min-width: 600px) {
      .steve-header {
        grid-column: 2 / 14;
        /* Row gap is 0 at this breakpoint, so carry the full 40px here. */
        padding-bottom: calc(40rem / var(--default-rem-px-count));
      }

      .steve-cards {
        grid-column: 2 / 14;
        /*
          A nested 12-column grid with the same gutter as the page grid, so
          card edges land on the page grid lines. steve-card-span is set
          inline from the card count: 2 cards span 6, 3 span 4, 4 span 3.
          Anything past four keeps the quarter width and wraps.
        */
        grid-template-columns: repeat(12, 1fr);
        gap: calc(40rem / var(--default-rem-px-count))
          var(--between-column-padding);
      }

      .steve-card {
        grid-column: span var(--steve-card-span, 4);
      }
    }
  `,
];
